export default "__VITE_ASSET__0fe1b89a__"